import { createCache } from '../../../../shared/utils/cacheFactory';
import { possibleTypes } from '@viasat/res-apps-lib/build/types/mv';
import { BillingTypePolicies } from './constants';

export const cacheFactory = () =>
  createCache({
    possibleTypes,
    typePolicies: {
      ...BillingTypePolicies,
      GetAccountInfoPayload: {
        keyFields: [],
      },
      GetInitialAccountInfoPayload: {
        keyFields: [],
      },
      GetConfigurations: {
        keyFields: [],
      },
      GetTransactionIdPayload: {},
      Plan: {
        fields: {
          characteristics: {
            merge: true,
          },
        },
      },
    },
  });
